var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.45 3.36328L20.9 3.36328M0.999999 19.9008L4.54375 19.9008M1 3.36328L5.72501 3.36328M9.26876 19.9008L20.9 19.9008M16.3563 11.632L20.9 11.632M1 11.632L11.6313 11.632",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72494 3.3625C5.72494 4.66728 6.78267 5.72501 8.08745 5.72501C9.39222 5.72501 10.45 4.66728 10.45 3.3625C10.45 2.05773 9.39222 1 8.08745 1C6.78267 1 5.72495 2.05773 5.72494 3.3625Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6313 11.632C11.6313 12.9368 12.689 13.9945 13.9938 13.9945C15.2986 13.9945 16.3563 12.9368 16.3563 11.632C16.3563 10.3273 15.2986 9.26953 13.9938 9.26953C12.689 9.26953 11.6313 10.3273 11.6313 11.632Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54379 19.9016C4.54379 21.2063 5.60152 22.2641 6.9063 22.2641C8.21107 22.2641 9.2688 21.2063 9.2688 19.9016C9.2688 18.5968 8.21107 17.5391 6.9063 17.5391C5.60152 17.5391 4.54379 18.5968 4.54379 19.9016Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.94f1b97c0db71fa4660c83e6f0f92740.svg";
export { ForwardRef as ReactComponent };